var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: ["select-recipients", _vm.currentECircular.type] },
    [
      _c(
        "div",
        { staticClass: "table-header" },
        [
          _c("span", { staticClass: "tree-arrow" }),
          _vm._v(" "),
          _vm.isTenantEcircular
            ? [
                _c("span", { staticClass: "tree-zone" }, [
                  _vm._v(_vm._s(_vm.$t("eCircular.floor"))),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "tree-trade-name" }, [
                  _vm._v(_vm._s(_vm.$t("eCircular.tradeName"))),
                ]),
                _vm._v(" "),
                _vm.showUserTypeCol
                  ? _c("span", { staticClass: "tree-contact-types" }, [
                      _vm._v(_vm._s(_vm.$t("userType.name"))),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("span", { staticClass: "tree-premises" }, [
                  _vm._v(_vm._s(_vm.$t("eCircular.premises"))),
                ]),
                _vm._v(" "),
                _vm.showMarketingType
                  ? _c("span", { staticClass: "tree-marketing-type" }, [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("tenancy.marketingType")) +
                          "\n      "
                      ),
                    ])
                  : _vm._e(),
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.isVendorEcircular
            ? [
                _c("span", { staticClass: "tree-company-id" }, [
                  _vm._v(_vm._s(_vm.$t("tenancy.companyId"))),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "tree-company-name" }, [
                  _vm._v(_vm._s(_vm.$t("eCircular.companyName"))),
                ]),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticClass: "tree-recipient-type",
                    staticStyle: { "padding-left": "15px" },
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.$t("userType.name")) +
                        "\n      "
                    ),
                  ]
                ),
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.isTenancyEcircular
            ? [
                _c("span", { staticClass: "tree-recipient-type" }, [
                  _vm._v(_vm._s(_vm.$t("eCircular.recipientType.label"))),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "tree-trade-name" }, [
                  _vm._v(_vm._s(_vm.$t("eCircular.tradeName"))),
                ]),
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.isAddOperation && _vm.treeData.length
            ? _c("i", {
                class: _vm.renderTableSelectIcon(),
                on: { click: _vm.selectAllTrees },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.isDelOperation
            ? _c("span", { staticClass: "operate-placeholder" })
            : _vm._e(),
        ],
        2
      ),
      _vm._v(" "),
      _vm._l(_vm.treeData, function (list) {
        return _c("RecipientsTree", {
          key: list.id,
          attrs: {
            list: list,
            eCircularType: _vm.currentECircular.type,
            selectOneLeaf: _vm.selectOneLeaf,
            selectOneRoot: _vm.selectOneRoot,
            operate: _vm.operate,
            showMarketingType: _vm.showMarketingType,
            expanded: list.expanded,
            deleteOneRoot: _vm.deleteOneRoot,
            deleteOneLeaf: _vm.deleteOneLeaf,
          },
          on: {
            updateExpanded: function (val) {
              list.expanded = val
            },
          },
        })
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }